import { Inject, Injectable, InjectionToken } from '@angular/core';

import moment from 'moment-timezone';

import { SubscriptionStatus } from '@recruitee/http/types';

export const APP_ENV = new InjectionToken('App Env');

@Injectable()
export class SubscriptionBannerHelpers {
  public MonthlyLegacyMigrationDates: Record<
    'lastBillingCycleStartDate' | 'dueDate',
    moment.Moment
  > = {
    lastBillingCycleStartDate:
      this.env === 'production' ? moment('2022-05-01') : moment('2022-02-28'),
    dueDate: this.env === 'production' ? moment('2022-06-15') : moment('2022-03-15'),
  };

  private isLastBillingCycleForMonthlyLegacy = moment().isSameOrAfter(
    this.MonthlyLegacyMigrationDates['lastBillingCycleStartDate'],
  );

  constructor(@Inject(APP_ENV) private env: string) {}

  // If monthly company ends in May we should add one more month because company will renew one last time.
  public isLastBillingCycleForMonthlyLegacyPerCompany = (
    currentPeriodEnd: string,
    subscriptionStatus: SubscriptionStatus,
  ) => {
    const currentPeriodEndMoment = moment(currentPeriodEnd);
    return (
      this.isLastBillingCycleForMonthlyLegacy &&
      (currentPeriodEndMoment.month() > 4 || // month() is 0-indexed so May is month 4
        (currentPeriodEndMoment.month() === 4 && subscriptionStatus === 'non_renewing') ||
        currentPeriodEndMoment
          .add(30, 'd')
          .diff(this.MonthlyLegacyMigrationDates['lastBillingCycleStartDate'], 'd') <= 0)
    );
  };

  public diffDates = (
    date: string | moment.Moment,
    unitOfTime: 'days' | 'months' = 'days',
  ): number =>
    Math.round(
      (moment.isMoment(date) ? date : moment(date).endOf(unitOfTime)).diff(
        moment(),
        unitOfTime,
        unitOfTime === 'months',
      ),
    );
}
